import { useEffect, useState } from 'react';
import '../styles/project.css';
const Buffer = window.Buffer;

const Project = ({ proj, key }) => {
    const projectName = proj.projectName;
    let projectImagesArray = [];
    const [images, setImages] = useState('');

    useEffect(() => {
        convertImages();
    }, []);

    // `data:${object.imageExtensionType};base64, ${Buffer.from(object.bufferData).toString('base64')}`
    // above code will render for dynamic extension types
    const convertImages = () => {
        let fetchImages;
        if (proj.projectImages != undefined) {
            projectImagesArray = proj.projectImages;
            fetchImages = projectImagesArray.map((image, index) => {
                console.log(image.data.data);

                let base64Str = window.btoa(String.fromCharCode(...new Uint8Array(image.data.data)));
                <img src={`data:image/${image.contentType};base64,${image.data.data.toString('base64')}`}></img>
                // <img src={`data:${image.contentType};base64, ${Buffer.from(image.data).toString('base64')}`}></img>
                return <div key={index}><img src={`data:image/jpg;base64,${base64Str}`} /></div>

                // const blob = new Blob([Int8Array.from(image.data.data)], { type: image.contentType });
                // const myImage = window.URL.createObjectURL(blob);
                // return <div key={index}><img src={myImage} /></div>
            });
            setImages(fetchImages);
            //projectImageSrc = `data:${proj.projectImages.contentType};base64, ${Buffer.from(proj.projectImages.data).toString('base64')}`;
        }
    }


    return (

        <div key={key}>
            <h1>{projectName}</h1>
            {
                images
            }
        </div>

        // <div className="container project">
        //     {/* Start - Main Section Banner Image and Description */}
        //     <div className="banner d-flex justify-content-center">
        //         <img className="img-fluid" src="assets/images/project/jeevandeep-1.jpg" alt="jeevandeep" />
        //     </div>
        //     <div className="project-content py-5">
        //         <div className="heading-2 title">
        //             Jeevandeep Medicals
        //         </div>
        //         <div id="project-location" className="content-3 sub-title">
        //             Nashik, India
        //         </div>
        //         <div className="row py-4 justify-content-between">
        //             <div className="col-6 px-3">
        //                 <div className="description">
        //                     <p className="content-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fuga non consequatur aliquid nemo porro iste officia magnam ipsa, nostrum quidem?</p>
        //                     <p className="content-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fuga non consequatur aliquid nemo porro iste officia magnam ipsa, nostrum quidem?</p>
        //                 </div>
        //             </div>
        //             <div className="col-4 px-3">
        //                 <div id="project-details">
        //                     <p className="content-0">Client: Uday Somani</p>
        //                     <p className="content-0">Size: 600 sq.ft.</p>
        //                     <p className="content-0">Completed in: 2023</p>
        //                     <p className="content-0">Awards: Mh best</p>
        //                 </div>
        //             </div>
        //         </div>
        //         {/* End - Main Section Banner Image and Description */}

        //         { /* Start - Masonry Grid for site images */}
        //         <div className="project-masonry row" data-masonry='{"percentPosition": true }' >
        //             <div className="col-12 col-md-6">
        //                 <div className="project-img-box">
        //                     <img className="project-image" src="/assets/images/project/img5.jpg" alt="" />
        //                     <figcaption className="img-caption content-0"> Lorem ipsum, dolor sit amet consectetur adipisicing elit. Aliquam, reiciendis.</figcaption>
        //                 </div>
        //             </div>
        //             <div className="col-12 col-md-6">
        //                 <div className="project-img-box">
        //                     <img className="project-image" src="/assets/images/project/img1.jpg" alt="" />
        //                 </div>
        //             </div>
        //             <div className="col-12 col-md-6">
        //                 <div className="project-img-box">
        //                     <img className="project-image" src="/assets/images/project/img2.jpg" alt="" />
        //                 </div>
        //             </div>
        //             <div className="col-12 col-md-6">
        //                 <div className="project-img-box">
        //                     <img className="project-image" src="/assets/images/project/img3.jpg" alt="" />
        //                 </div>
        //             </div>
        //             <div className="col-12 col-md-6">
        //                 <div className="project-img-box">
        //                     <img className="project-image" src="/assets/images/project/img4.jpg" alt="" />
        //                 </div>
        //             </div>
        //         </div>
        //         { /* End - Masonry Grid for site images */}
        //     </div>
        // </div>
    );
}

export default Project;